import { Base, Component, Mixins, Prop } from '@/vue-property-decorator'
import BaseCssVarInject from '../../../../../components/baseCssVarInject'
import style from './style.module.scss'

/** 收藏图标 带动画*/
type Props = {
  /** 收藏图标地址 */
  iconUrl: string
}

@Component<IconAnimation>({
  name: 'IconAnimation'
})
export default class IconAnimation extends Mixins<
  Base<unknown, Props>,
  BaseCssVarInject<{ cssType: ''; ['--icon-animation-transform']: string }>
>(Base, BaseCssVarInject) {
  @Prop()
  private iconUrl!: Required<Props>['iconUrl']
  render() {
    return (
      <apng-canvas
        class={style['icon-animation']}
        src={this.iconUrl}
        numPlays={1}
      />
    )
  }
}
